"use strict";
exports.__esModule = true;
exports.checkDim = exports.checkNonDecreasing = void 0;
function checkNonDecreasing(values) {
    if (values.length === 0) {
        return false;
    }
    for (var i = 0; i < values.length - 1; i++) {
        if (values[i] > values[i + 1]) {
            return false;
        }
    }
    return true;
}
exports.checkNonDecreasing = checkNonDecreasing;
function checkDim(values, lenBreakpoints) {
    if (typeof values === 'string' || values.length === lenBreakpoints + 1) {
        return true;
    }
    return false;
}
exports.checkDim = checkDim;
